import { Group } from '@mantine/core';
import type { TFunction } from 'i18next';
import { TableColumn } from '../../../components/table/table';
import { secondaryLight } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { Link } from '../../../ui-library/link/link';
import { Text } from '../../../ui-library/typography/typography';
import { TruncatedText } from '../../adherence/risk-analysis/truncated-text';
import type { TaskRecord } from '../../tasks-table/tasks-table.type';

/**
 * Table columns configuration for the agentic process table
 */
const getAgenticProcessTableColumns = (
  navigateToAgenticMap: (taskId: string) => void,
  t: TFunction,
): TableColumn<TaskRecord>[] => [
  {
    key: 'title',
    label: 'Code',
    sortable: true,
    width: '150px',
    render: (_, row) => (
      <Link href={row.url}>
        <Group gap={5} align="center" style={{ display: 'inline-flex' }}>
          <Text size="small" weight="medium">
            {row.title}
          </Text>
          <Icon name="open_in_new" variant="filled" size={16} color={secondaryLight} style={{ cursor: 'pointer' }} />
        </Group>
      </Link>
    ),
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    width: '300px',
    render: (_, row) => <TruncatedText text={row.name || '-'} maxLength={50} textSize="small" />,
  },
  {
    key: 'type',
    label: 'Type',
    sortable: true,
    width: '120px',
    render: (value) => <Text size="small">{value ? String(value) : '-'}</Text>,
  },
  {
    key: 'points',
    label: t('common.estimation'),
    sortable: true,
    width: '100px',
    render: (value) => <Text size="small">{value != null ? String(value) : '-'}</Text>,
  },
  {
    key: 'id',
    label: 'Actions',
    width: '100px',
    render: (_, row) => (
      <Button size="xs" radius="xl" variant="secondary" onClick={() => navigateToAgenticMap(row.id)}>
        View Agentic Map
      </Button>
    ),
  },
];

export { getAgenticProcessTableColumns };
